<template>
  <div class="main__content">
    <div class="table__header_bar">
      <InputSearch isFilter @detectSearchValue="searchTableHandler" />
    </div>
    <Table
      v-if="!!tableOfReportsDart"
      :content="getTableData"
      @tableHandler="tableHandler"
    />
    <v-skeleton-loader v-else type="table" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Table from '@/elements/Table';
export default {
  components: {
    Table,
  },

  data() {
    return {};
  },

  async created() {
    this.$store.dispatch('getTableOfReportsDart');
  },

  computed: {
    ...mapGetters(['tableOfReportsDart']),

    getTableData() {
      return this.tableOfReportsDart?.table?.items;
    },
  },

  methods: {
    searchTableHandler(val) {
      this.$store.commit('SET_TABLE_SORT_DATA', { search: val });
      this.$store.dispatch('getTableOfReportsDart');
    },
    tableHandler() {
      this.$store.dispatch('getTableOfReportsDart');
    },
  },
};
</script>
